<script setup lang="ts">
import { ref } from 'vue';

type Props = {
    /** パネルの初期状態
     *
     * trueにすれば最初から開いた状態になる
     */
    defaultOpen?: boolean;

    /** パネルのタイトル */
    title: string;

    /** 無効化状態 */
    disabled?: boolean;

    /** パネルの背景色 */
    variant?: 'default' | 'filled' | 'outlined';
};

const props = withDefaults(defineProps<Props>(), {
    defaultOpen: false,
    disabled: false,
    variant: 'default',
});

const isOpen = ref<boolean>(props.defaultOpen);

const toggle = () => {
    if (!props.disabled) {
        isOpen.value = !isOpen.value;
    }
};
</script>

<template>
    <v-expansion-panels :model-value="isOpen ? [0] : []" :class="['v-expansion-panel-custom', `variant-${variant}`]">
        <v-expansion-panel :title="''" :disabled="disabled" @group:selected="toggle">
            <v-expansion-panel-title>
                <div class="d-flex align-center">
                    <span class="text-subtitle-1 font-weight-medium">{{ title }}</span>
                </div>
            </v-expansion-panel-title>

            <v-expansion-panel-text>
                <slot></slot>
            </v-expansion-panel-text>
        </v-expansion-panel>
    </v-expansion-panels>
</template>

<style scoped>
.v-expansion-panel-custom {
    box-shadow: none;
}

.v-expansion-panel-custom .v-expansion-panel {
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    margin-bottom: 8px;
}

.v-expansion-panel-custom .v-expansion-panel:last-child {
    margin-bottom: 0;
}

.v-expansion-panel-custom .v-expansion-panel--disabled {
    opacity: 0.6;
    pointer-events: none;
}
</style>
